export class Operadores_Funcoes_Recursos
{
    id_opfr: number = 0;
    id_oper: number = 0;
    id_fnrc: number = 0;
    acesso_opfr: string = '';
}